
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/home-equity",
      function () {
        return require("private-next-pages/home-equity.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/home-equity"])
      });
    }
  